import { filter, take } from 'rxjs/operators';
import { ApplicationRef, inject, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

import { environment } from '../environments/environment';
import { AuthSyncService } from '../app/auth-sync.service';
import { User } from '../swagger';

/**
 * Partner namespace (`/partner`): JWT + active partner record on the server.
 * Joins `/user/{userId}` for this partner only — not a broadcast to all partners.
 */
@Injectable()
export class PartnerSocket extends Socket {
  constructor(readonly authSyncService: AuthSyncService) {
    super(
      {
        url: `${environment.BASE_PATH}/partner`,
        options: {
          autoConnect: false,
          transports: ['websocket'],
        },
      },
      inject(ApplicationRef)
    );
    this.authSyncService.$user
      .pipe(
        filter((user): user is User => !!user && user.type === User.TypeEnum.PARTNER),
        take(1)
      )
      .subscribe(() => {
        this.connectSocketWithAuth(this.authSyncService.getToken());
      });
  }

  private connectSocketWithAuth(token: string) {
    this.ioSocket.io.opts.query = {
      token,
    };
    this.connect();
  }
}
